module.exports = __webpack_public_path__ + "files/42ca49717275cd3896645170a41b9cd4.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activity-2.png
// module id = 1379
// module chunks = 59